import { injectGlobal } from 'styled-components';

import theme from './theme';
import Oneer from '../../static/fonts/Oneer.ttf';
import Chunq from '../../static/fonts/Chunq.ttf';

// Global styles shared across the app
injectGlobal`
  * {
    box-sizing: border-box;
  }

  body {
    background: ${theme.colors.icecream};
    font-family: 'Oneer';
    font-size: 40px;
    color: ${theme.colors.grayDark};
    margin: 0;
    padding-bottom: 1.5rem;
  }

  @media (max-width: 767px) {
    .popup-content {
      width: 90% !important;
    }
  }

  @font-face {
    font-family: 'Oneer';
    font-style: normal;
    font-weight: 400;
    src: url(${Oneer}) format('truetype');
  }

  @font-face {
    font-family: 'Chunq';
    font-style: normal;
    font-weight: 400;
    src: url(${Chunq}) format('truetype');
  }
  
  .flex {
    display: flex;
  }
  
  .flex-col {
    display: flex;
    flex-direction: column;
  }

  .customBorderTop {
    border-top: 5px dotted #373535;
    }
  .customBorderBottom {
      border-bottom: 5px dotted #373535;
  }
  .customBorderRight {
      border-right: 5px dotted #373535;
  }
  .customBorderLeft {
      border-left: 5px dotted #373535;
  }
  .plate2-desktop {
      display: block;
  }
  @media (max-width: 767px) {
    .customBorderRight {
      border-right: none;
    }
    .customBorderBottom {
      border-bottom: none;
    }
    .customBorderTop {
      border-top: none;
    }
    .customBorderLeft {
      border-left: none;
    }
    .plate2-desktop {
      display: none;
    }
  }
  .relative {
    position: relative
  }
`;
